import { Box } from "@mui/joy"

const OrderWrapper = ({children}) => {
    return <Box>
        {children}
    </Box>
}

export default OrderWrapper;